export default function formatTime(current) {
  const h = Math.floor(current / 3600);
  const m = Math.floor(current / 60);
  let s = Math.floor(current % 60);

  if (s < 10) {
    s = '0' + s;
  }

  if (h > 0) {
    return h + ':' + m + ':' + s;
  }
  return m + ':' + s;
}
